import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

import { provideLottieOptions } from 'ngx-lottie';
import { LottieComponent } from 'ngx-lottie';
import player from 'lottie-web';

import { NoAccessComponent } from './no-access/no-access.component';
import { AuthButtonComponent } from './auth-button/auth-button.component';
import { LoadingPageComponent } from './loading-page/loading-page.component';
import { HotGlueComponent } from './hot-glue/hot-glue.component';
import { PriceTableComponent } from './price-table/price-table.component';
import { UpgradePromptModalComponent } from './upgrade-prompt-modal/upgrade-prompt-modal.component';

@NgModule({
  declarations: [
    NoAccessComponent,
    AuthButtonComponent,
    LoadingPageComponent,
    PriceTableComponent,
    HotGlueComponent,
    UpgradePromptModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    LottieComponent,
    RouterModule // Required for routing and routerLink usage in components
  ],
  exports: [
    NoAccessComponent,
    AuthButtonComponent,
    LoadingPageComponent,
    PriceTableComponent,
    HotGlueComponent,
    UpgradePromptModalComponent// Export components to make them reusable
  ],
  providers: [
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class SharedModule {}

